import { BuscadorComponent } from "./BuscadorCursos/BuscadorComponent";
import { Botonera } from '../Portafolio/helpers/botonera';

import "../Portafolio/src/css/portafolio_home.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./src/css/portafolio_categorias.css";
import "./src/css/buscador_resultados.css";

import React, { useState } from "react";
import { Button, Alert } from 'react-bootstrap';

import Footer from "../Footer";
import MobileHomeSlider from './HomeSlider/mobileHomeSlider';

import { HomeSliderPeten } from './HomeSlider/HomeSliderPeten';
import { RegionalBannerPeten } from './Handlers/RegionalBannerPeten';

function PortafolioHomePeten() {

    return (

        <>

        <RegionalBannerPeten />

            <div className="portafolio_phome_area">
                <div className="portafolio_header">

                    <Botonera />

                    <div className="buscador_area">
                        <BuscadorComponent />
                    </div>

                </div>

                <HomeSliderPeten />

            </div>

            <div id="mobile_slider_area" className="mobile_slider_area">
                <MobileHomeSlider />
            </div>

            <Footer />
        </>

    );

}

export default PortafolioHomePeten;